// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__113dy","question":"Question_question__3uOGc","description":"Question_description__12NNU"};